(function() {
	'use strict';

	angular
		.module('app.setup')
		.config(function ($translateProvider) {
			$translateProvider.translations('en_us',
				{ 'factoryGeneralSettings.conversionFactor': 'Conversion Factor ({{fromCurrency}} to {{toCurrency}})' }
			);
		})
		.controller('factoryGeneralSettings', factoryGeneralSettings);

	factoryGeneralSettings.$inject = ['$rootScope', '$scope', '$filter', '$timeout',
		'$compile', '$uibModal', '$window', 'factorySettingService', 'inventoryActionConfigService', 'siteService', 'storeService', 'sftpConfigService', 'leandnaConnectKeyConfigService'];

	function factoryGeneralSettings($rootScope, $scope, $filter, $timeout, $compile,
			$uibModal, $window, factorySettingService, inventoryActionConfigService, siteService, storeService, sftpConfigService, leandnaConnectKeyConfigService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		vm.months = [{id: 0, text: 'January'}, {id: 1, text: 'February'},
			{id: 2, text: 'March'}, {id: 3, text: 'April'},
			{id: 4, text: 'May'}, {id: 5, text: 'June'},
			{id: 6, text: 'July'}, {id: 7, text: 'August'},
			{id: 8, text: 'September'}, {id: 9, text: 'October'},
			{id: 10, text: 'November'}, {id: 11, text: 'December'}];
		vm.startingDaysOfWeek = [{id: 2, text: 'Monday'},{id: 7, text: 'Saturday'},{id: 1, text: 'Sunday'}];
		vm.siteTypes = ['Customer', 'Warehouse', 'Pilot', 'Internal', 'Other'];
		vm.yesNoOptions = [{id: true, text: 'Yes'}, {id: false, text: 'No'}];
		vm.alertingOptions = ['Default (none until data is uploaded, then all)', 'No Alerting', 'Metrics Only', 'Components'];
		vm.advancedInventoryOptimizationOptions = ['Disabled', 'Enabled'];
		vm.demandScenarioModelingEnabledOptions = ['Disabled', 'Enabled'];
		vm.currencies = [];
		vm.entities = [];
		vm.divisions = [];
		vm.businessUnits = [];
		vm.regions = [];

		vm.isLeanDNACustomerAdmin = $rootScope.authz.isLeanDNACustomerAdmin();
		vm.customerName = adminConfig.customer.name;
		var backupValues = {};

		vm.factoryAlias = globalConfig.user.authFacts[adminConfig.factory.id].alias;
		backupValues.factoryAlias = vm.factoryAlias;
		vm.saveSettings = saveSettings;
		vm.resetValues = resetValues;
		vm.changesMade = changesMade;
		vm.tagTransform = tagTransform;
		vm.refreshResults = refreshResults;
		vm.updateFactoryStartDate = updateFactoryStartDate;
		vm.validInputs = validInputs;
		vm.siteId = adminConfig.factory.id;
		
		vm.deletePublicKey = deletePublicKey;
		vm.copyPublicKey = copyPublicKey;
		vm.uploadSFTP	= uploadSFTP;

		vm.deleteLeandnaConnectKey = deleteLeandnaConnectKey;
		vm.createLeandnaConnectKey = createLeandnaConnectKey;

		vm.displayTab = 'https';
		vm.selectTab = function (tabName) {
			vm.displayTab = tabName;
		};

		vm.open = function() {
			$timeout(function() {
				vm.opened = true;
			});
		};

		init();
		loadSFTPSetup();
		loadLeandnaConnectKeySetup();

		function getCurrencies() {
			factorySettingService.getCurrencies(adminConfig.factory.id).then(function(currencies){
				var data = [];
				if (currencies !== '') {
					data = currencies;
				}
				vm.currencies = data;
			});
		}

		function getTimeZones() {
			factorySettingService.getTimeZones(adminConfig.factory.id).then(function(timeZones){
				var data = [];
				if (timeZones !== '') {
					data = timeZones;
				}
				vm.timeZones = data;
			});
		}

		function getUsers() {
			siteService.getUsersForSite(adminConfig.factory.id, true)
				.then(function initUsers(users) {
					vm.users = users;
					for (var i = 0; i < vm.users.length; i++) {
						var user = vm.users[i];
						user.name = user.firstName + ' ' + user.lastName;
					}
				});
		}

		function getEntitiesOrDivisionsOrBusinessUnitsByCustomer(type) {
			factorySettingService.getEntitiesOrDivisionsOrBusinessUnitsByCustomer(type, adminConfig.factory.id).then(function(results){
				var data = [];
				if (results !== '') {
					data = results;
					if (data.length > 0) {
						data = data.map(function (obj) {
							return {
								'name': obj.name,
								'ndx': obj.name
							};
						});
					}
				}
				if (type === 'Entities') {
					vm.entities = data;
				} else if (type === 'Divisions') {
					vm.divisions = data;
				} else if (type === 'BusinessUnit') {
					vm.businessUnits = data;
				} else if (type == 'Regions') {
					vm.regions = data;
				}
			});
		}

		function tagTransform(newTag) {
			var item = {
				'name': newTag
			};
			return item;
		}

		function refreshResults($select) {
			var search = $select.search,
				list = angular.copy($select.items),
				FLAG = -1;
			//remove last user input
			list = list.filter(function (item) {
				return item.id !== FLAG;
			});

			if (!search) {
				//use the predefined list
				$select.items = list;
			} else {
				//manually add user input and set selection
				var userInputItem = {
					id: FLAG,
					name: search,
					ndx: 'tag-' + search,
					extraLabel: ' (Click or press Enter to create)'
				};
				$select.items = [userInputItem].concat(list);
				$select.selected = $select.items[0];
				$select.activeIndex = 0;
				$select.activate($select.items[0]);
			}
		}

		function loadDropDowns() {
			getEntitiesOrDivisionsOrBusinessUnitsByCustomer('Entities');
			getEntitiesOrDivisionsOrBusinessUnitsByCustomer('Divisions');
			getEntitiesOrDivisionsOrBusinessUnitsByCustomer('BusinessUnit');
			getEntitiesOrDivisionsOrBusinessUnitsByCustomer('Regions');
		}

		function init() {
			getCurrencies();
			getTimeZones();
			getUsers();
			if (vm.isLeanDNACustomerAdmin) {
				loadDropDowns();
			}
			factorySettingService.getFactoryGeneralSettings(adminConfig.factory.id)
				.then(function initDefaultMetricType(settings) {
					vm.startingDayOfWeek = settings.startingDayOfWeek;
					vm.startingMonthOfFiscalYear = settings.startingMonthOfFiscalYear;
					vm.emailSuffix = settings.emailSuffix;
					vm.siteType = settings.siteType;
					// show blank for 1970-01-01
					if (settings.factoryStartDate < 24 * 60 * 60 * 1000) {
						vm.factoryStartDate = null;
					} else {
						vm.factoryStartDate = moment(settings.factoryStartDate).toDate();
					}
					vm.currencyCode = settings.currencyCode;
					vm.customerCurrencyCode = settings.customerCurrencyCode;
					vm.conversionFactor = settings.conversionFactor;
					vm.entity = settings.entity;
					vm.division = settings.division;
					vm.businessUnit = settings.businessUnit;
					vm.region = settings.region;
					vm.leanTransformStateMachine = settings.leanTransformStateMachine;
					vm.useLeanLoadStateMachine = settings.useLeanLoadStateMachine;
					vm.timeZone = settings.timeZone;
					// Convert boolean to string for display
					vm.advancedInventoryOptimization = settings.advancedInventoryOptimization === true ? 'Enabled' : 'Disabled';
					vm.demandScenarioModelingEnabled = settings.demandScenarioModelingEnabled === true ? 'Enabled' : 'Disabled';
					// convert bit mask to separate booleans
					if (settings.uploadAlertingLevel === undefined ||
							settings.uploadAlertingLevel === null) {
						settings.alertLevel = 'Default (none until data is uploaded, then all)';
					} else if (settings.uploadAlertingLevel === 0) {
						settings.alertLevel = 'No Alerting';
					} else if (settings.uploadAlertingLevel === 64) {
						settings.alertLevel = 'Metrics Only';
					} else {
						settings.alertLevel = 'Components';
						vm.alertingOptionalTables = settings.uploadAlertingLevel >= 8;
						if (vm.alertingOptionalTables) {
							settings.uploadAlertingLevel -= 8;
						}
						vm.alertingSupplyDemandTables = settings.uploadAlertingLevel >= 4;
						if (vm.alertingSupplyDemandTables) {
							settings.uploadAlertingLevel -= 4;
						}
						vm.alertingBaseTables = settings.uploadAlertingLevel >= 2;
						if (vm.alertingBaseTables) {
							settings.uploadAlertingLevel -= 2;
						}
						vm.alertingAnalytics = settings.uploadAlertingLevel >= 1;
					}
					vm.alertLevel = settings.alertLevel;

					backupValues.startingDayOfWeek = vm.startingDayOfWeek;
					backupValues.startingMonthOfFiscalYear = vm.startingMonthOfFiscalYear;
					backupValues.emailSuffix = vm.emailSuffix;
					backupValues.siteType = vm.siteType;
					backupValues.factoryStartDate = vm.factoryStartDate;
					backupValues.currencyCode = vm.currencyCode;
					backupValues.customerCurrencyCode = vm.customerCurrencyCode;
					backupValues.conversionFactor = vm.conversionFactor;
					backupValues.entity = vm.entity;
					backupValues.division = vm.division;
					backupValues.businessUnit = vm.businessUnit;
					backupValues.region = vm.region;
					backupValues.leanTransformStateMachine = vm.leanTransformStateMachine;
					backupValues.useLeanLoadStateMachine = vm.useLeanLoadStateMachine;
					backupValues.timeZone = vm.timeZone;
					backupValues.advancedInventoryOptimization = vm.advancedInventoryOptimization;
					backupValues.demandScenarioModelingEnabled = vm.demandScenarioModelingEnabled;
					backupValues.alertLevel = vm.alertLevel;
					backupValues.alertingAnalytics = vm.alertingAnalytics;
					backupValues.alertingBaseTables = vm.alertingBaseTables;
					backupValues.alertingSupplyDemandTables = vm.alertingSupplyDemandTables;
					backupValues.alertingOptionalTables = vm.alertingOptionalTables;
				});
		}

		function getCurrency() {
			var selectedCurrency = _.find(vm.currencies, function(currency) {
				return currency.currencyCode === vm.currencyCode;
			});
			return selectedCurrency;
		}

		function getValueWithOutTag(value) {
			var data = angular.copy(value);
			if (('' + data).indexOf('tag-') === 0) {
				data = data.substring(4);
			}
			return data;
		}

		function saveSettings() {
			var siteHierarchyChanged = false;
			var settings = {};
			if (backupValues.startingDayOfWeek !== vm.startingDayOfWeek) {
				settings.startingDayOfWeek = vm.startingDayOfWeek;
			}
			if (backupValues.startingMonthOfFiscalYear !== vm.startingMonthOfFiscalYear) {
				settings.startingMonthOfFiscalYear = vm.startingMonthOfFiscalYear;
			}
			if (backupValues.emailSuffix !== vm.emailSuffix) {
				settings.emailSuffix = vm.emailSuffix;
			}
			if (backupValues.factoryAlias !== vm.factoryAlias) {
				siteHierarchyChanged = true;
				settings.factoryAlias = vm.factoryAlias;
			}
			if (vm.isLeanDNACustomerAdmin && backupValues.siteType !== vm.siteType) {
				settings.siteType = vm.siteType;
			}
			if (vm.isLeanDNACustomerAdmin && backupValues.factoryStartDate !== vm.factoryStartDate) {
				settings.factoryStartDate = vm.factoryStartDate;
				// convert null back to default starting date. api can't differentiate null from "not sent"
				if (settings.factoryStartDate === null) {
					settings.factoryStartDate = '1970-01-01';
				}
			}
			if (backupValues.currencyCode !== vm.currencyCode) {
				settings.currencyCode = vm.currencyCode;
			}
			if (backupValues.customerCurrencyCode !== vm.customerCurrencyCode) {
				settings.customerCurrencyCode = vm.customerCurrencyCode;
			}
			if (backupValues.conversionFactor !== vm.conversionFactor ||
				backupValues.currencyCode !== vm.currencyCode ||
				backupValues.customerCurrencyCode !== vm.customerCurrencyCode
			) {
				settings.conversionFactor = vm.conversionFactor;
			}
			if (vm.isLeanDNACustomerAdmin && backupValues.leanTransformStateMachine !== vm.leanTransformStateMachine) {
				settings.leanTransformStateMachine = vm.leanTransformStateMachine;
			}
			if (vm.isLeanDNACustomerAdmin && backupValues.useLeanLoadStateMachine !== vm.useLeanLoadStateMachine) {
				settings.useLeanLoadStateMachine = vm.useLeanLoadStateMachine;
			}
			if (vm.isLeanDNACustomerAdmin && backupValues.timeZone !== vm.timeZone) {
				settings.timeZone = vm.timeZone;
			}
			if (vm.isLeanDNACustomerAdmin && backupValues.advancedInventoryOptimization !== vm.advancedInventoryOptimization) {
				settings.advancedInventoryOptimization = vm.advancedInventoryOptimization === 'Enabled';
			}
			if (vm.isLeanDNACustomerAdmin && backupValues.demandScenarioModelingEnabled !== vm.demandScenarioModelingEnabled) {
				settings.demandScenarioModelingEnabled = vm.demandScenarioModelingEnabled === 'Enabled';
			}

			if (!vm.leanTransformStateMachine && vm.useLeanLoadStateMachine === true) {
				$rootScope.$emit('toast', {
					'message': '`Use LeanLoad State Machine` cannot be enabled without setting `LeanTransform State Machine`',
					'success': false,
					'time': 15000
				});

				return;
			}

			var isDropdownReloadRequired = false;
			var isHierarchyConfirmationRequired = false;
			if (vm.isLeanDNACustomerAdmin) {
				vm.entity = getValueWithOutTag(vm.entity);
				vm.division = getValueWithOutTag(vm.division);
				vm.businessUnit = getValueWithOutTag(vm.businessUnit);
				vm.region = getValueWithOutTag(vm.region);

				if (backupValues.entity !== vm.entity) {
					siteHierarchyChanged = true;
					settings.entity = vm.entity;
					isDropdownReloadRequired = true;
					isHierarchyConfirmationRequired = true;
				}
				if (backupValues.division !== vm.division) {
					siteHierarchyChanged = true;
					settings.division = vm.division;
					isDropdownReloadRequired = true;
					isHierarchyConfirmationRequired = true;
				}
				if (backupValues.businessUnit !== vm.businessUnit) {
					siteHierarchyChanged = true;
					settings.businessUnit = vm.businessUnit;
					isDropdownReloadRequired = true;
					isHierarchyConfirmationRequired = true;
				}
				if (backupValues.region !== vm.region) {
					siteHierarchyChanged = true;
					settings.region = vm.region;
					isDropdownReloadRequired = true;
				}

				if (vm.alertLevel === vm.alertingOptions[0]) {
					// use -1 as stand-in for null, which is hard to distinguish from "not changed"
					settings.uploadAlertingLevel = -1;
				} else if (vm.alertLevel === 'No Alerting') {
					settings.uploadAlertingLevel = 0;
				} else if (vm.alertLevel === 'Metrics Only') {
					settings.uploadAlertingLevel = 64;
				} else {
					settings.uploadAlertingLevel = 0;
					if (vm.alertingOptionalTables) {
						settings.uploadAlertingLevel += 8;
					}
					if (vm.alertingSupplyDemandTables) {
						settings.uploadAlertingLevel += 4;
					}
					if (vm.alertingBaseTables) {
						settings.uploadAlertingLevel += 2;
					}
					if (vm.alertingAnalytics) {
						settings.uploadAlertingLevel += 1;
					}
				}
			}

			if (vm.customerFactory) {
				if (vm.customerFactory.user) {
					var newUserNdx = vm.customerFactory.user.ndx;
					if (newUserNdx) {
						inventoryActionConfigService.saveDefaultResponsible(
							adminConfig.factory.id, newUserNdx);
					}
					inventoryActionConfigService.updateAllInventoryActionConfigState(adminConfig.factory.id,
						vm.customerFactory.enableInventoryActions === 'Yes');
				}
			}
			if (isHierarchyConfirmationRequired) {
				var confirmScope = $scope.$new();
				confirmScope.messageKey = 'modal.confirm.reconfigureSiteHierarchy';
				confirmScope.messageValues = {
					entity: vm.entity,
					division: vm.division,
					businessUnit: vm.businessUnit
				};
				confirmScope.fallbackText = 'You are reconfiguring the site hierarcy. '
						+ 'Entity \'' + vm.entity
						+ '\' will now be part of Division \'' + vm.division
						+ '\', and Division \'' + vm.division + '\' will now be under Business Unit \''
						+ vm.businessUnit
						+ '\'. This change will impact all sites in this hierarchy. '
						+ 'Are you sure you want to proceed with these changes?';
				confirmScope.buttonText = 'Save';
				var opts = {
					scope: confirmScope,
					templateUrl: '/application/f/core/confirm.html'
				};

				var instance = $uibModal.open(opts);
				confirmScope.closeDialog = function () {
					instance.close();
					confirmScope.$destroy();
				};

				confirmScope.yes = function () {
					instance.close();
					confirmScope.$destroy();
					postSettings (settings, backupValues, siteHierarchyChanged, isDropdownReloadRequired);
				};
			} else {
				postSettings(settings, backupValues, siteHierarchyChanged, isDropdownReloadRequired);
			}
		}

		function postSettings(settings, backupSettings, siteHierarchyChanged, isDropdownReloadRequired) {
			var response = factorySettingService.saveFactoryGeneralSettings(settings, adminConfig.factory.id).then(function (response) {
				if (response === 'Settings saved successfully') {
					var toastMessageTimeout = 15000;
					var toastMessage = siteHierarchyChanged ? 
						'Changes to site alias/entity/division/business unit/region have not been propagated to some supply chain reports. These reports will show the new values the next time the analytics engine runs.' :
						'Settings saved successfully';
					$rootScope.$emit('toast', {
						'message': toastMessage,
						'success': true,
						'time': toastMessageTimeout
					});

					if (vm.currencyCode !== backupValues.currencyCode) {
						var selectedCurrency = getCurrency();
						if (selectedCurrency) {
							globalConfig.browser.currencySymbol = selectedCurrency.currencySymbol;
						}
					}

					backupValues.startingDayOfWeek = vm.startingDayOfWeek;
					backupValues.startingMonthOfFiscalYear = vm.startingMonthOfFiscalYear;
					backupValues.emailSuffix = vm.emailSuffix;
					backupValues.factoryAlias = vm.factoryAlias;
					backupValues.siteType = vm.siteType;
					backupValues.factoryStartDate = vm.factoryStartDate;
					backupValues.currencyCode = vm.currencyCode;
					backupValues.customerCurrencyCode = vm.customerCurrencyCode;
					backupValues.conversionFactor = vm.conversionFactor;
					backupValues.leanTransformStateMachine = vm.leanTransformStateMachine;
					backupValues.useLeanLoadStateMachine = vm.useLeanLoadStateMachine;
					backupValues.timeZone = vm.timeZone;
					backupValues.advancedInventoryOptimization = vm.advancedInventoryOptimization;
					backupValues.demandScenarioModelingEnabled = vm.demandScenarioModelingEnabled;
					if (vm.isLeanDNACustomerAdmin) {
						backupValues.entity = vm.entity;
						backupValues.division = vm.division;
						backupValues.businessUnit = vm.businessUnit;
						backupValues.region = vm.region;

						if (isDropdownReloadRequired) {
							loadDropDowns();
						}
					}
					if (siteHierarchyChanged || settings.startingMonthOfFiscalYear) {
						var reloadUrl = $window.location.href.split('?')[0] + '?toastMessage=' + toastMessage + '&toastTimeout=' + toastMessageTimeout;
						$window.location.href = reloadUrl;
						$window.location.reload();
					}

				} else {
					$rootScope.$emit('toast', {
						'message': response,
						'success': false
					});
				}
			});
		}

		function resetValues() {
			vm.startingDayOfWeek = backupValues.startingDayOfWeek;
			vm.startingMonthOfFiscalYear = backupValues.startingMonthOfFiscalYear;
			vm.emailSuffix = backupValues.emailSuffix;
			vm.factoryAlias = backupValues.factoryAlias;
			vm.siteType = backupValues.siteType;
			vm.factoryStartDate = backupValues.factoryStartDate;
			vm.currencyCode = backupValues.currencyCode;
			vm.customerCurrencyCode = backupValues.customerCurrencyCode;
			vm.conversionFactor = backupValues.conversionFactor;
			vm.entity = backupValues.entity;
			vm.division = backupValues.division;
			vm.businessUnit = backupValues.businessUnit;
			vm.region = backupValues.region;
			vm.leanTransformStateMachine = backupValues.leanTransformStateMachine;
			vm.useLeanLoadStateMachine = backupValues.useLeanLoadStateMachine;
			vm.timeZone = backupValues.timeZone;
			vm.advancedInventoryOptimization = backupValues.advancedInventoryOptimization;
			vm.demandScenarioModelingEnabled = backupValues.demandScenarioModelingEnabled;
			vm.alertLevel = backupValues.alertLevel;
			vm.alertingAnalytics = backupValues.alertingAnalytics;
			vm.alertingBaseTables = backupValues.alertingBaseTables;
			vm.alertingSupplyDemandTables = backupValues.alertingSupplyDemandTables;
			vm.alertingOptionalTables = backupValues.alertingOptionalTables;
		}

		function changesMade() {
			return (
				vm.startingDayOfWeek !== backupValues.startingDayOfWeek ||
				vm.startingMonthOfFiscalYear !== backupValues.startingMonthOfFiscalYear ||
				vm.emailSuffix !== backupValues.emailSuffix ||
				vm.factoryAlias !== backupValues.factoryAlias ||
				vm.siteType !== backupValues.siteType ||
				vm.factoryStartDate !== backupValues.factoryStartDate ||
				vm.currencyCode !== backupValues.currencyCode ||
				vm.customerCurrencyCode !== backupValues.customerCurrencyCode ||
				vm.conversionFactor !== backupValues.conversionFactor ||
				vm.entity !== backupValues.entity ||
				vm.division !== backupValues.division ||
				vm.businessUnit !== backupValues.businessUnit ||
				vm.region !== backupValues.region ||
				vm.leanTransformStateMachine !== backupValues.leanTransformStateMachine ||
				vm.useLeanLoadStateMachine !== backupValues.useLeanLoadStateMachine ||
				vm.timeZone !== backupValues.timeZone ||
				vm.advancedInventoryOptimization !== backupValues.advancedInventoryOptimization ||
				vm.demandScenarioModelingEnabled !== backupValues.demandScenarioModelingEnabled ||
				vm.alertLevel !== backupValues.alertLevel ||
				vm.alertingAnalytics !== backupValues.alertingAnalytics ||
				vm.alertingBaseTables !== backupValues.alertingBaseTables ||
				vm.alertingSupplyDemandTables !== backupValues.alertingSupplyDemandTables ||
				vm.alertingOptionalTables !== backupValues.alertingOptionalTables);
		}

		function updateFactoryStartDate() {
			if (backupValues.siteType === 'Pilot' && vm.siteType !== 'Pilot') {
				vm.factoryStartDate = moment().toDate();

				if (vm.siteType === 'Customer' || vm.siteType === 'Warehouse') {
					factoryTypeUpdate();
				} else {
					vm.showInventoryActionsConfigurations = false;
					vm.customerFactory = {};
				}
			}
		}

		function factoryTypeUpdate() {
			vm.showInventoryActionsConfigurations = true;
			vm.customerFactory = {};
		}

		function validInputs() {
			if (vm.conversionFactor == null || vm.conversionFactor === '') {
				return false;
			}
			if (vm.isLeanDNACustomerAdmin && (!vm.entity || !vm.businessUnit || !vm.division)) {
				return false;
			}
			if (backupValues.siteType === 'Pilot' && vm.siteType !== 'Pilot') {
				if (vm.siteType === 'Customer' || vm.siteType === 'Warehouse') {
					if (vm.customerFactory.user && vm.customerFactory.user.ndx && 
						vm.customerFactory.enableInventoryActions) {
						return true;
					} else {
						return false;
					}
				}
				return true;
			}
			return true;
		}

		function copyPublicKey(sftpKey) {
			navigator.clipboard.writeText(sftpKey.sshPublicKeyBody);

			$rootScope.$emit('toast', {
				'message': 'Public Key copied to clipboard',
				'success': true
			});
		}

		function deletePublicKey(deleteKey) {
			var confirmScope = $scope.$new();
			confirmScope.additionalText = ' delete this Public Key';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};
			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				instance.close();
				confirmScope.$destroy();

				sftpConfigService.deleteSFTPKey(adminConfig.factory.id,deleteKey).then(function (message) {
					var toastMessage = '';
					var isSuccessful = false;
					if (_.isString(message)) {
						toastMessage = message;
						isSuccessful = true;
						$scope.$broadcast('reloadTable');
						loadSFTPSetup();
					}

					$rootScope.$emit('toast', {
						'message': toastMessage,
						'success': isSuccessful
					});
				});
			};
		}

		function uploadSFTP() {
			var uploadSFTPKeyFormScope = $scope.$new();
			uploadSFTPKeyFormScope.siteId = adminConfig.factory.id;
			
			var opts = {
				scope: uploadSFTPKeyFormScope,
				templateUrl: '/application/f/setup/factory/general/sftp-public-key-form.html',
				size: 'md',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			uploadSFTPKeyFormScope.closeDialog = function () {
				instance.close();
				uploadSFTPKeyFormScope.$destroy();
			};

			uploadSFTPKeyFormScope.result = function (message, isSuccessful) {
				$rootScope.$emit('toast', { 'message': message, 'success': isSuccessful });
				if (isSuccessful) {
					$scope.$broadcast('reloadTable');
					closeModal(instance, uploadSFTPKeyFormScope);
					loadSFTPSetup();
				}

				if (message === '') {
					closeModal(instance, uploadSFTPKeyFormScope);
				}
			};
		}

		function closeModal(instance, formScope) {
			instance.close();
			formScope.$destroy();
		}


		function loadSFTPSetup() {
			if (vm.isLeanDNACustomerAdmin) {
				sftpConfigService.getSFTPKeyList(adminConfig.factory.id).then(function (sftpKeyList) {
					if (sftpKeyList === 204) {
						vm.sftpKeysEmpty = true;
					} else {
						vm.sftpKeys = sftpKeyList;
						vm.sftpKeysEmpty = false;
					}
				});
			}
		}
		function loadLeandnaConnectKeySetup() {
			if (vm.isLeanDNACustomerAdmin) {
				leandnaConnectKeyConfigService.getLeandnaConnectKeyList(adminConfig.factory.id).then(function (leandnaConnectKeyList) {
					if (leandnaConnectKeyList === 200) {
						vm.leandnaConnectKeysEmpty = true;
					} else vm.leandnaConnectKeysEmpty = false;
					vm.leandnaConnectKeys = leandnaConnectKeyList;
					// }
				});
			}
		}

		function deleteLeandnaConnectKey(deleteKey) {
			var confirmScope = $scope.$new();
			confirmScope.additionalText = ' delete this LeanDNA Connect Key';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};
			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				instance.close();
				confirmScope.$destroy();

				leandnaConnectKeyConfigService.deleteLeandnaConnectKey(adminConfig.factory.id, deleteKey).then(function (message) {
					var toastMessage = '';
					var isSuccessful = false;
					if (_.isString(message)) {
						toastMessage = message;
						isSuccessful = true;
						$scope.$broadcast('reloadTable');
						loadLeandnaConnectKeySetup();
					}

					$rootScope.$emit('toast', {
						'message': toastMessage,
						'success': isSuccessful
					});
				});
			};
		}


		function createLeandnaConnectKey() {
			var createLeandnaConnectKeyFormScope = $scope.$new();
			createLeandnaConnectKeyFormScope.siteId = adminConfig.factory.id;

			var opts = {
				scope: createLeandnaConnectKeyFormScope,
				templateUrl: '/application/f/setup/factory/general/leandna-connect-key-form.html',
				size: 'md',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			createLeandnaConnectKeyFormScope.closeDialog = function () {
				instance.close();
				createLeandnaConnectKeyFormScope.$destroy();
			};

			createLeandnaConnectKeyFormScope.result = function (message, isSuccessful) {
				$rootScope.$emit('toast', { 'message': message, 'success': isSuccessful });
				if (isSuccessful) {
					$scope.$broadcast('reloadTable');
					closeModal(instance, createLeandnaConnectKeyFormScope);
					loadLeandnaConnectKeySetup();
				}

				if (message === '') {
					closeModal(instance, createLeandnaConnectKeyFormScope);
				}
			};
		}

	}
})();
